/* eslint-disable react/style-prop-object */
import React, { useContext, useEffect, useReducer, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import EmptyContent from "components/EmptyContent";
import File from "components/File";
import FileUploader from "components/FileUploader";
import { FolderContext } from "features/documents";
import { ReactComponent as IconFolder } from "assets/img/icons/icon_folder.svg";
import Modal from "shared/ui/Modal";
import ModalShare from "components/ModalShare";
import NotificationsList from "components/NotificationsList";
import PageHeader from "components/PageHeader";
import SubHead from "features/documents/components/SubHead";
import { UserContext } from "features/account";
import { createLinkInvitation } from "features/documents";
import { toast } from "react-toastify";
import DocumentIllustration from "components/DocumentIllustration";
import FiligraneImage from "assets/img/watermark_2.png";
import Checkbox from "shared/ui/Checkbox";
import Button from "shared/ui/Button";
import {Button_Style, Button_Type} from "shared/ui/Button/Button";
import VideoFrame from "shared/ui/VideoFrame";
import Alert from "shared/ui/Alert";
import UnauthorizedPage from "components/UnauthorizedPage";
import { AppState, Sections_dossier, Type_dossier } from "shared/types/types";
import DossierPage from "./IDLocker/DossierPage";
import { Action, reducer } from "features/documents";

const initialState: AppState = {
    dossiers:[],
    ui:{
        route:"grid",
        showCreate:false
    }
};

function appReducer(state: AppState, action:Action){
    return reducer(state,action);
}

const IDLockerDetail = () => {
    const { user, isVerified } = useContext(UserContext);
    const { folder, tryRemoveFolder, tryGetFolder, tryChangeVisibility, tryAddFileToFolder, partners } = useContext(FolderContext);
    const type = user?.type;
    const [confirmModalIsOpen, setConfirmModalIsOpen] = useState(false);
    const [modalShareIsOpen, setModalShareIsOpen] = useState(false);
    const [shareLink, setShareLink] = useState("");
    const navigate = useNavigate();


    let { id } = useParams();
    const [state, dispatch] = useReducer(appReducer, initialState);
    const route = state.ui.route;



    useEffect(() => {
        const fetchFolder = async () => {
            await tryGetFolder(type, id);
        };
        fetchFolder();
        const tryCreateShareLink = async () => {
            const response = await createLinkInvitation(type, id);
            setShareLink(response?.data.link);
        };
        tryCreateShareLink();
    }, [id, type]);


    const handleUploadFile = async (files: any, fileType: string) => {
        files.map(async (file: any) => {
            try {
                await tryAddFileToFolder(type, id, file, fileType);
                // Fetch folder when add folder because reactivity doesn't work on the response addFolder
                await tryGetFolder(type, folder?.id.toString());
            } catch (error) {
                console.log(error);
            }
        });
    };
    const handleReturn = () => {
        navigate(-1);
    };

    const fileUploaderProps = {
        className: "mb-0",
        title: "Ajouter",
        allowedFormats:
            "application/pdf, image/jpeg, image/png, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        onDelete: () => console.log("delete"),
        isList: false,
    };

    const handleChangeVisibility = async () => {
        await tryChangeVisibility(folder?.id);
    };

    const handleShareFolder = async () => {
        setModalShareIsOpen(true);
    };

    if (isVerified === false && user?.type === "individual") {
        return (
            <UnauthorizedPage
                message="Votre compte n'est pas vérifié!"
                alertText=" Pour vérifier votre compte veuillez ajouter au moins un document d'identité en suivi."
            />
        );
    }

    return (
        <>
            <PageHeader
              showBackBtn={true}
                title={"ID Locker"}
                description={folder?.name}
                notification={user?.type === 'individual'}
                protectAlert={user?.type === 'individual'}
            >
            </PageHeader>
            <div className="content__body">
                  <div className="row">
                      <div className="col-lg-12">
                          {folder && (
                            <SubHead
                              folderName={folder.name}
                              folderId={folder.id}
                              folderVisibility={folder.visibility}
                              handleReturn={handleReturn}
                              handleSecret={handleChangeVisibility}
                              handleShareFolder={handleShareFolder}
                              handleDeleteFolder={() => setConfirmModalIsOpen(true)}
                            />
                          )}
                          {(folder?.typeDossier !== Type_dossier.LOCATION_LOGEMENT && folder?.name !== Type_dossier.LOCATION_LOGEMENT) ? (
                            <div>
                                <div
                                  className="d-flex gap-1 mb-2 "
                                  style={{ flexWrap: "wrap" }}>
                                    {folder?.ownerId.toString() === user?.id?.toString() && (
                                      <FileUploader
                                        {...fileUploaderProps}
                                        onChange={(files) => {
                                            handleUploadFile(files, "VERBAL");
                                        }}
                                        isList={false}
                                      />
                                    )}
                                    {folder?.documents && folder?.documents?.length > 0 ? (
                                      folder?.documents.map((file: any, index: any) => (
                                        <File
                                          key={index}
                                          file={file}
                                          isEditable={folder?.ownerId.toString() === user?.id?.toString()}
                                        />
                                      ))
                                    ) : (
                                      <EmptyContent text="Aucun document dans ce dossier" />
                                    )}
                                </div>
                                {/*<div className="col-lg-4">
                                    <NotificationsList filter="id-locker" limit={10} />
                                </div>*/}
                            </div>) : (
                            <div>
                                <div>
                                    <DossierPage
                                      dossier={folder}
                                      routeLeft={(route as any).left as Sections_dossier}
                                      garantDetail={(route as any).garantDetail}
                                      dispatch={dispatch}
                                    />
                                </div>
                            </div>
                          )}
                      </div>
                  </div>
                {confirmModalIsOpen && (
                  <Modal
                    title="Supprimer un dossier"
                    type="error"
                    labelOnConfirm="Supprimer"
                    isOpen={confirmModalIsOpen}
                    onClose={() => setConfirmModalIsOpen(false)}
                    onConfirm={async () => {
                        const response = await tryRemoveFolder(Number(id));
                        if (response) {
                            navigate(-1);
                            toast.info("Votre dossier a bien été supprimé", {
                                position: "top-center",
                            });
                        } else {
                            toast.error("Il y a eu un problème...", {
                                position: "top-center",
                            });
                        }
                    }}>
                      <p>Êtes vous sûr de vouloir supprimer ce dossier ? La suppression est définitive.</p>
                  </Modal>
                )}
                {modalShareIsOpen && (
                  <ModalShare
                    shareLink={shareLink}
                    isOpen={modalShareIsOpen}
                    onClose={() => setModalShareIsOpen(false)}
                    folder={folder}
                    partners={partners}
                  />
                )}
            </div>
        </>
    );
};

export default IDLockerDetail;
